<mat-dialog-content class="mat-typography gridContent">
    <div class="div" [innerHTML]="img"></div>
</mat-dialog-content>

<mat-divider></mat-divider>

<div class="gridButton">
    <button class="buttonCancelar" mat-button mat-dialog-close>Fechar</button>
</div>